var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.appClass,attrs:{"id":"app"}},[(_vm.useHeader)?_c('header-claro'):_vm._e(),_c('div',{staticClass:"app__content"},[_c('router-view')],1),_c('g-tag-manager',{attrs:{"google-tag-id":_vm.googleTagId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }